import { gql } from '@apollo/client';

export const assignorQuery = gql`
  query ($idFDEm: ID!) {
    getAssignor(idFDEm: $idFDEm) {
      idFDEm
      idFCed
      cnpj
      cpf
      fullName
      personalEmail
      areaCode
      phone
      inEndorsementSigner
      inGuarantor
      inIssuesPromissoryNote
      inRelatedParty
      inRepresentative
      inSignsCessionAgreement
      isSoleSigner
    }
  }
`;
